<script>
  export default {
    name: "HoursPopover",
    props: {
      business: {
        required: true,
        type: Object,
      },
    },
    data() {
      return { isVisible: false };
    },
    beforeUpdate() {
      // There is a bug where if the hour slot is focused
      // at some point, it remains focused when clicking away
      // and returning to same popup causing the hours popover
      // to appear in weird spots on the map without it being
      // moused over or focused again.
      const elem = document.activeElement;
      if (elem.id && elem.id == "hours_pop") {
        this.$refs.hour_slot.blur();
      }
    },
    methods: {
      onFocusPopover() {
        this.isVisible = !this.isVisible;
      },
      onFocusOut() {
        setTimeout(() => {
          this.isVisible = false;
        }, 100);
      },
    },
    computed: {
      openHours() {
        const allHours = this.business?.all_opening_hours?.stringHrs;
        const other = {};
        for (const hours of allHours) {
          // day: hours key value pairs
          other[hours[0][0]] = hours.map((h) => {
            return h[1];
          });
        }
        return Object.entries(other);
      },
    },
  };
</script>
<template>
  <el-popover
    placement="bottom-start"
    title="Open Hours:"
    trigger="hover"
    ref="hoursPopover"
    v-model="isVisible"
  >
    <table class="open-hours-table">
      <template v-for="([day, hours], dayIdx) in openHours">
        <tr
          v-for="(hour, idx) in hours"
          :key="`${day}-${idx}`"
          :class="{ 'first-row': dayIdx === 0 }"
        >
          <td v-if="idx === 0" class="day" :rowspan="hours.length">
            {{ day }}:
          </td>
          <td><span v-html="hour"></span></td>
        </tr>
      </template>
    </table>

    <template #reference>
      <el-button
        @click="onFocusPopover"
        @focusout.native="onFocusOut"
        ref="hour_slot"
        :id="business.url_name + 'hours_pop'"
        class="hours-btn"
      >
        <slot name="hour"></slot>
      </el-button>
    </template>
  </el-popover>
</template>

<style lang="scss" scoped>
  @import "../styles/variables";

  .open-hours-table {
    color: $primary-text;
    td {
      padding-bottom: 0.3rem;
      &:first-child {
        padding-right: 10px;
      }
    }
    .first-row {
      font-weight: bold;
    }
    .day {
      text-align: right;
      vertical-align: top;
    }
  }
  .hours-btn {
    border: none;
    padding: 0;
    &:hover,
    &:focus {
      background-color: transparent;
    }
    &:focus {
      outline-width: 1px !important;
      outline: 2px auto #0060cb;
      outline-offset: 0;
    }
  }
</style>
